module.exports = __webpack_public_path__ + "static/media/5_7.bd0b5240.png";